import { slideDown, slideUp } from '../../../js/theme/helpers';

export class Accordion {
	// Default state for the accordion.
	isOpen = false;

	// Speed of opening/closing accordion in milliseconds.
	speed = 300;

	constructor({
		control, content, group, autoCloseSiblings = false,
	}) {
		if (control && content) {
			// Assign control, content, and group to Accordion instance
			this.control = control;
			this.content = content;
			this.group = group;
			this.autoCloseSiblings = autoCloseSiblings;

			// Attach an event listener to the control element when an instance of the Accordion class is created.
			// The listener listens for a 'click' event and calls the `handleControlClick` method.
			this.control.addEventListener('click', this.handleControlClick);
		}
	}

	open = () => {
		// Close any other open accordion sections in the same group.
		if (this.autoCloseSiblings && this.hasOpenSiblings()) {
			this.closeOpenSiblings();
		}

		this.control.setAttribute('aria-expanded', 'true');
		slideDown(this.content, `${this.speed}ms`);
		this.isOpen = true;
	};

	close = () => {
		// Update Accordion attributes.
		this.control.setAttribute('aria-expanded', 'false');
		slideUp(this.content, `${this.speed}ms`);
		this.isOpen = false;
	};

	hasOpenSiblings = () => {
		let hasOpenSiblings = false;
		const { accordions } = this.group;
		if (accordions.length) {
			for (let i = 0; i < accordions.length; i++) {
				if (accordions[i] !== this && accordions[i].isOpen) {
					hasOpenSiblings = true;
					break;
				}
			}
		}

		return hasOpenSiblings;
	};

	closeOpenSiblings = () => {
		const { accordions } = this.group;
		if (accordions.length) {
			accordions.forEach((accordion) => {
				if (accordion !== this) {
					accordion.close();
				}
			});
		}
	};

	handleControlClick = () => {
		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	};
}
